export const APP_TOKEN_HEADER = 'x-app-token';
export const CLIENT_ID_HEADER = 'client-id';
export const WORKSPACE_ID_HEADER = 'workspace-id';
